var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var APIKeyService = /** @class */ (function () {
    function APIKeyService(api) {
        var _this = this;
        this.fetchApiKey = function (app) { return _this.API.get("/users?type=apikey-v1&app=".concat(app)); };
        this.createApiKeyItem = function (apikeyItem) {
            return _this.API.post('/users', {
                user: {
                    app: apikeyItem.app,
                    type: 'apikey-v1',
                    name: apikeyItem.name,
                },
            });
        };
        this.updateApiKeyItem = function (updatedAPIkey) {
            return _this.API.patch("/users/".concat(updatedAPIkey.id), __assign({}, updatedAPIkey));
        };
        this.deleteApiKeyItem = function (apikeyId) { return _this.API.delete("/users/".concat(apikeyId)); };
        this.API = api;
    }
    return APIKeyService;
}());
export { APIKeyService };
